import QmPictureLibrary from './src/index'

/* istanbul ignore next */
QmPictureLibrary.install = function (Vue) {
  Vue.component(QmPictureLibrary.name, QmPictureLibrary)
}

export default QmPictureLibrary
